import { HypotheticalWaterfallInput } from "features/financial-reporting/HypotheticalWaterfallInput";
import { useFundListSuspense } from "gen/endpoints/fund-entities/fund-entities";
import { useHypotheticalWaterfallCategoriesRetrieveSuspense } from "gen/endpoints/hypothetical-waterfall/hypothetical-waterfall";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { nowAsIsoDate } from "shared/utils/DateUtils";

export const HypotheticalWaterfallCreatePage: React.FC = () => {
  const { fundFamilyId } = useRequiredStringParams();

  const { data: codeData } = useHypotheticalWaterfallCategoriesRetrieveSuspense(
    fundFamilyId,
    { effective_date: nowAsIsoDate() },
  );

  const { data: fundList } = useFundListSuspense({
    fund_family_ids: [fundFamilyId],
    fund_ids: Object.keys(codeData.fund_id_to_allocation_details),
  });

  const transactionCodeToAmount = codeData.transaction_codes.reduce<
    Record<string, string>
  >((acc, code) => {
    acc[code.id] = "";
    return acc;
  }, {});

  const fundIdToTransactionCodeToAmount = fundList.reduce<{
    [key: string]: { [key: string]: string };
  }>((acc, fund) => {
    acc[fund.id!] = transactionCodeToAmount;
    return acc;
  }, {});

  return (
    <HypotheticalWaterfallInput
      fundIdToTransactionCodeToAmount={fundIdToTransactionCodeToAmount}
    />
  );
};
